












import Vue from 'vue';
import SubscribeItem from './SubscribeItem.vue';
import Topic from '../../models/Topic';
import settingsClient from '../../apis';
import commonVuex from '../../../common/vuex/common';

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    SubscribeItem,
  },
  props: {
    refreshId: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    loadSubscribes() {
      this.loadTopics();
    },
    deleteSubscribe(key: number) {
      this.topics.splice(key, 1);
    },
    loadTopics() {
      settingsClient.getTopics().success((r: any) => {
        this.$store.commit('SET_TOPICS', r.topics);
        this.$emit('loaded');
      });
    },
  },
  mounted() {
    this.loadSubscribes();
  },
  watch: {
    refreshId() {
      this.loadTopics();
    },
  },
});
